import { Address } from 'viem'

export enum OracleAdapterCheckSeverity {
  High = 'HIGH',
  Medium = 'MEDIUM',
  Low = 'LOW',
  Info = 'INFO',
}

export enum OracleAdapterMethodology {
  MarketPrice = 'Market Price',
  ExchangeRate = 'Exchange Rate',
  Twap = 'TWAP',
  Unknown = 'Unknown',
}

export interface OracleAdapterCheck {
  id: string
  message: string
  pass: boolean
  severity: OracleAdapterCheckSeverity
}

export interface OracleAdapter {
  address: Address
  base: Address
  quote: Address
  checks: OracleAdapterCheck[]
  isFromApi?: boolean
  label?: string
  methodology: OracleAdapterMethodology
  name: string
  provider: string
}

export interface UseOracleAdaptersParams {
  chainId: number
  enabled?: boolean
}

export type OracleChecksStatus = 'positive' | 'negative' | 'mixed'

